import classNames from 'classnames'
import Link from 'next/link'
import { ExhibitionWithWorks } from '../lib/apiClient'

interface ExhibitionProps {
  exhibition: ExhibitionWithWorks;
  showHeroImage?: boolean;
  showEditLink?: boolean;
  children?: React.ReactNode
  showImage?: boolean;
}

export const ExhibitionListItem: React.FC<ExhibitionProps> = ({
  exhibition: e,
  showImage,
  showEditLink,
  children,
}) => (
  <div className="exhibition" key={e.id}>
    {
      e.heroImageUrl && showImage && (
        <Link href={`/exhibition/${e.id}`}>
          {/* eslint-disable-next-line */}
          <img
            src={e.heroImageUrl}
            alt={e.heroImageAltText || e.name}
          />
        </Link>
      )
    }
    <div className={classNames('horizontal-links')}>
      <h2>
        <Link href={`/${showEditLink ? 'admin/' : ''}exhibition/${e.id}`}>
          {e.name}
        </Link>
      </h2>
    </div>
    {children}
  </div>
)
